export default "__VITE_ASSET__BgO8ztsM__"